// src/pages/compliance/SowSourceBar.jsx
// Shown instead of the upload dropzone once a SOW has already been picked
// for this engagement session — lets RAID/TVR/SMP/Obligation/STM reuse the
// same file instead of asking the user to upload it again on every tab.
// RTM is deliberately not wired to this: RtmUploadCard takes a distinct
// requirements document, not the general SOW (see RtmPipeline's docstring).
import { FileText, RotateCcw } from "lucide-react";
import PropTypes from "prop-types";

function formatSize(bytes) {
  if (bytes < 1024) return `${bytes} B`;
  if (bytes < 1024 * 1024) return `${(bytes / 1024).toFixed(0)} KB`;
  return `${(bytes / (1024 * 1024)).toFixed(1)} MB`;
}

function formatRelative(timestamp) {
  const seconds = Math.max(0, Math.floor((Date.now() - timestamp) / 1000));
  if (seconds < 60) return "just now";
  const minutes = Math.floor(seconds / 60);
  if (minutes < 60) return `${minutes}m ago`;
  const hours = Math.floor(minutes / 60);
  if (hours < 24) return `${hours}h ago`;
  return `${Math.floor(hours / 24)}d ago`;
}

export default function SowSourceBar({ file, uploadedAt, onReplace }) {
  return (
    <div className="c-sow-bar">
      <span className="c-sow-bar-icon">
        <FileText size={16} />
      </span>
      <div className="c-sow-bar-text">
        <div className="c-sow-bar-name">{file.name}</div>
        <div className="c-sow-bar-meta">
          {formatSize(file.size)} · uploaded {formatRelative(uploadedAt)} · used for every module
        </div>
      </div>
      <button type="button" className="c-sow-bar-replace" onClick={onReplace}>
        <RotateCcw size={13} /> Replace
      </button>
    </div>
  );
}

SowSourceBar.propTypes = {
  file: PropTypes.instanceOf(File).isRequired,
  uploadedAt: PropTypes.number.isRequired,
  onReplace: PropTypes.func.isRequired,
};
